import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import {
  rootApiResponse,
  clearDefaultError,
} from '../HeaderContainer/actions';
import {
  successResponse,
  errorResponse,
} from '../../devUtils/commonUtils';
import { utils } from '../../devUtils';
import { SET_YESBANK_ZINGER_CARDS_FAQ, DEFAULT_ACTION } from './constants';

const yesBankZingerCardFaQSuccess = (payload) => ({ type: SET_YESBANK_ZINGER_CARDS_FAQ, payload });

export const yesBankZingerCardFaQ = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.getHandler(api, endpoint.GET_YES_BANK_ZINGER_CARD_FAQ, payload, authPrerequist);
    dispatch(yesBankZingerCardFaQSuccess(response));
    return dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, '')));
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};



// WEBPACK FOOTER //
// client/containers/YesBankFaQs/actions.js